const messages = {
  title: '¡Gracias por tu compra, {name}!',
  titleError: '¡Ups! Parece que hubo un error',
  subTitle: 'Si tienes dudas, escribenos a ',
  email: 'notifications@mymoons.mx',
  buttonText: 'Intentar de nuevo',
}

export default messages
